(function () {
  const waitingForms = new WeakSet();
  const resumingForms = new WeakSet();
  const identificationTimeout = 1500;

  document.addEventListener(
    "submit",
    async (event) => {
      const form = event.target;
      if (!form.matches("form.newsletter-form, form.footer-subscribe-form")) {
        return;
      }
      if (resumingForms.has(form)) return;
      if (waitingForms.has(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!form.checkValidity()) return;
      if (form.querySelector('[name="form_type"]')?.value !== "customer") return;

      const emailInput = form.querySelector('[name="contact[email]"]');
      const email = emailInput?.value.trim();
      const privacy = window.Shopify?.customerPrivacy;
      if (
        !email ||
        !privacy?.analyticsProcessingAllowed() ||
        !privacy?.marketingAllowed() ||
        !window.klaviyo?.identify
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      waitingForms.add(form);
      const submitter = event.submitter;
      const wasReadOnly = emailInput.readOnly;
      const previousBusyState = form.getAttribute("aria-busy");
      emailInput.readOnly = true;
      form.setAttribute("aria-busy", "true");
      let timeout;
      try {
        await Promise.race([
          Promise.resolve().then(() => window.klaviyo.identify({ email })),
          new Promise((resolve) => {
            timeout = setTimeout(resolve, identificationTimeout);
          }),
        ]);
      } catch {} finally {
        clearTimeout(timeout);
        emailInput.readOnly = wasReadOnly;
        if (previousBusyState === null) {
          form.removeAttribute("aria-busy");
        } else {
          form.setAttribute("aria-busy", previousBusyState);
        }
        waitingForms.delete(form);
        if (form.isConnected) {
          resumingForms.add(form);
          try {
            form.requestSubmit(submitter?.form === form ? submitter : undefined);
          } finally {
            resumingForms.delete(form);
          }
        }
      }
    },
    true
  );

  if (!window.Shopify?.customerPrivacy) {
    window.Shopify?.loadFeatures?.(
      [{ name: "consent-tracking-api", version: "0.1" }],
      () => {}
    );
  }
})();
